import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import SEPARefundForRefundOfRefundsViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/SEPA/SEPARefundForRefundOfRefundsViewModel";
import { TransferRefundForRefundOfRefundsView } from "../transferRefundForRefundOfRefundsView";

const SEPARefundForRefundOfRefundsView: ViewComponent<SEPARefundForRefundOfRefundsViewModel> = observer(({ vm }) => (
  <TransferRefundForRefundOfRefundsView key={vm.name} vm={vm} />
));

registerView(SEPARefundForRefundOfRefundsView, SEPARefundForRefundOfRefundsViewModel);
